module.exports = __webpack_public_path__ + "img/googleeye.1a0e1926.jpg";